import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useVenue } from '../../hooks/useVenue'
import { updateVenue } from '../../services/api/updateVenue'
import { EditEntityPage } from '../EditEntityPage/EditEntityPage'
import { buildVenueEditRows } from './helpers/buildVenueEditRows'

const venueNote = (
  <span><strong>Note</strong>: Used to manage static venues and placeholders (e.g. AV inventory system profiles) to enable tenant config.</span>
)

export function VenueEditPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()
  const { venue, isLoading, error } = useVenue(id ?? '')

  const rows = venue ? buildVenueEditRows(venue) : []

  async function handleSubmit(body: Record<string, unknown>) {
    await updateVenue(await getToken(), id!, body)
    navigate(`/venues/${id}`)
  }

  return (
    <EditEntityPage
      title={venue ? `Edit Venue - ${venue.name}` : 'Edit Venue'}
      backTo={`/venues/${id}`}
      note={venueNote}
      loadingLabel="venue"
      rows={rows}
      isLoading={isLoading}
      loadError={error}
      onSubmit={handleSubmit}
    />
  )
}
